<!-- UserDropdownMenu.vue -->
<template>
  <div class="dropdown-menu-container" ref="dropdownMenu">
    <!-- Información del usuario -->
    <div class="user-info-container">
      <div class="workspace-user-info user-profile__profile">
        <div class="workspace-user-info__info">
          <div class="workspace-user-info__name">
            {{ user.name ?? user.displayName }}
          </div>
          <div class="workspace-user-info__email">
            {{ user.email }}
          </div>
        </div>
      </div>
    </div>
    
    <!-- <div v-if="isAdmin" class="menu-item" @click="navigateToGroupsManagement">
      {{$t('navbar.group-management')}}
    </div>
    <div v-if="isAdmin" class="menu-item" @click="navigateToCreateGroups">
      {{$t('navbar.course-management')}}
    </div>
    <div v-if="isAdmin" class="menu-item" @click="navigateToInstitutionsManagement">
      Gestión de Instituciones
    </div>
    <div v-if="isAdmin" class="menu-item" @click="navigateToPracticalGuidesManagement">
      Gestión de Guías Prácticas
    </div> -->
    <div class="menu-item" @click="onLogout">{{$t('profile.logout')}}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

export default {
  name: "UserDropdownMenu",
  
  data() {
    return {
      isAdmin: false
    };
  },

  computed: {
    ...mapGetters("auth", ["user"])
  },

  async mounted() {
    await this.checkAdminStatus();
  },
  
  methods: {
    ...mapActions("auth", ["logout"]),
    
    async checkAdminStatus() {
      if (!this.user?.uid) return;
      
      try {
        const db = getFirestore();
        const adminRef = collection(db, 'admin');
        const q = query(adminRef, where('uid', '==', this.user.uid));
        const querySnapshot = await getDocs(q);
        this.isAdmin = !querySnapshot.empty;
      } catch (error) {
        this.isAdmin = false;
      }
    },
    
    // navigateToGroupsManagement() {
    //   if (this.$route.name !== 'groups-management') {
    //     this.$router.push({ name: 'groups-management' }).catch(() => {});
    //   }
    //   this.$emit('close');
    // },

    // navigateToCreateGroups(){
    //   if (this.$route.name !== 'create-groups-management'){
    //     this.$router.push({ name: 'create-groups-management'}).catch(() => {});
    //   }
    //   this.$emit('close');
    // },

    // navigateToInstitutionsManagement() {
    //   const path = `/${this.$i18n.locale}/educational-institutions-management`;
    //   if (this.$route.path !== path) this.$router.push(path);
    //   this.$emit('close');
    // },

    // navigateToPracticalGuidesManagement() {
    //   const path = `/${this.$i18n.locale}/practical-guides-management`;
    //   if (this.$route.path !== path) this.$router.push(path);
    //   this.$emit('close');
    // },
    
    async onLogout() {
      const result = await Swal.fire({
        title: this.$t("logout.title"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("logout.yes"),
        cancelButtonText: this.$t("logout.no"),
      });

      if (result.isConfirmed) {
        try {
          await this.logout();
          this.$router.push(`/${this.$i18n.locale}/principal-page`);
        } catch (error) {
          Swal.fire(
            "Error",
            "Hubo un problema al cerrar la sesión. Por favor, inténtalo de nuevo.",
            "error"
          );
        }
      }
    },
    
    navigateProject() {
      const path = `/${this.$i18n.locale}/projects`;
      if (this.$route.path !== path) this.$router.push(path);
      this.$emit('close');
    },
    
    navigateAcademy() {
      const path = `/${this.$i18n.locale}/academy`;
      if (this.$route.path !== path) this.$router.push(path);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.dropdown-menu-container {
  position: absolute;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 280px;
  width: 100%;
  overflow: hidden;
}

.user-info-container {
  padding: 18px 15px;
  border-bottom: 1px solid #eee;
  background-color: #f9f9f9;
}

.workspace-user-info {
  display: flex;
  align-items: center;
}

.workspace-user-info__info {
  width: 100%;
}

.workspace-user-info__name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 6px;
  color: #333;
}

.workspace-user-info__email {
  font-size: 14px;
  line-height: 20px;
  color: #666;
}

.menu-item {
  padding: 14px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  color: #444;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

/* Último elemento con un color destacado para Cerrar sesión */
.menu-item:last-child {
  border-top: 1px solid #eee;
  color: #e74c3c;
}
</style>